// extracted by mini-css-extract-plugin
module.exports = {"block":"table-not-found_block__2fSOr"};